import { Settings } from "luxon";
import type { Ref } from "vue";

export default defineNuxtPlugin((nuxtApp) => {
  const { locale } = nuxtApp.$i18n as { locale: Ref<string> };

  Settings.defaultLocale = locale.value;

  watch(locale, (value) => {
    Settings.defaultLocale = value;
  });
});